export default {
  cart: 'shopping cart'
}
